// TODO: Use GQL tag here instead of string concatenation

import {LinkType} from 'shared/types';

export const linkIsPublicPageQueryResultLinksShoppableLink = (
  link: PublicPageQueryResultLinksLink,
): link is PublicPageQueryResultLinksShoppableLink =>
  link.__typename === LinkType.ShoppableLink && 'productId' in link;

export const linkIsPublicPageQueryResultLinksExternalLink = (
  link: PublicPageQueryResultLinksLink,
): link is PublicPageQueryResultLinksExternalLink =>
  link.__typename === LinkType.ExternalLink && 'url' in link;

export const linkIsPublicPageQueryResultLinksAmazonAffiliateLink = (
  link: PublicPageQueryResultLinksLink,
): link is PublicPageQueryResultLinksAmazonAffiliateLink =>
  link.__typename === LinkType.AmazonAffiliateLink;

export const linkIsPublicPageQueryResultLinksDovetaleAffiliateLink = (
  link: PublicPageQueryResultLinksLink,
): link is PublicPageQueryResultLinksDovetaleAffiliateLink =>
  link.__typename === LinkType.DovetaleAffiliateLink && 'productId' in link;

export interface PublicPageQueryResultThemeSettings {
  backgroundColor: string;
  fontColor: string;
  primaryFont: string;
  secondaryFont?: string;
  backgroundStyle: BackgroundStyle;
  backgroundImage?: {url: string};
  linkCardShape: LinkCardShape;
  linkCardColor: string;
  linkCardFontColor: string;
}

export enum LinkCardShape {
  RoundedLarge = 'rounded_large',
  RoundedSmall = 'rounded_small',
  Square = 'square',
}

export enum BackgroundStyle {
  Image = 'image',
  SolidColor = 'solid_color',
}

export interface PublicPageQueryResultMedia {
  id: string;
  signedBlobId: string;
  url: string;
}

export interface PublicPageQueryResultLinksLink {
  __typename: LinkType;
  id: string;
  title: string;
}

export interface PublicPageQueryResultLinksExternalLink
  extends PublicPageQueryResultLinksLink {
  __typename: 'ExternalLink';
  url: string;
  media?: PublicPageQueryResultMedia;
}

export interface PublicPageQueryResultLinksAmazonAffiliateLink
  extends PublicPageQueryResultLinksLink {
  __typename: 'AmazonAffiliateLink';
  description: string;
  amazonPrice?: string;
  url: string;
  media?: PublicPageQueryResultMedia;
}

export interface PublicPageQueryResultLinksShoppableLink
  extends PublicPageQueryResultLinksLink {
  __typename: 'ShoppableLink';
  productId: string;
}

export interface PublicPageQueryResultLinksDovetaleAffiliateLink
  extends PublicPageQueryResultLinksLink {
  __typename: 'DovetaleAffiliateLink';
  productId: string;
}

export interface PublicPageQueryResultLinksMediaLink
  extends PublicPageQueryResultLinksLink {
  __typename:
    | 'SpotifyAlbumLink'
    | 'SpotifyArtistLink'
    | 'SpotifyPlaylistLink'
    | 'SpotifyPodcastLink'
    | 'SpotifyShowLink'
    | 'SpotifySongLink'
    | 'YouTubePlaylistLink'
    | 'YouTubeVideoLink';
  url: string;
}

export interface PublicPageQueryResultSocialMediaAccount {
  id: string;
  handle: string;
  network: string;
}

export interface PublicPageQueryResultPage {
  __typename: 'Page';
  id: string;
  bio: string;
  title: string;
  slug: string;
  storeUrl?: string;
  storefrontAccessToken?: string;
  themeSettings: PublicPageQueryResultThemeSettings;
  media?: PublicPageQueryResultMedia;
  links: (
    | PublicPageQueryResultLinksLink
    | PublicPageQueryResultLinksShoppableLink
    | PublicPageQueryResultLinksDovetaleAffiliateLink
    | PublicPageQueryResultLinksExternalLink
    | PublicPageQueryResultLinksMediaLink
    | PublicPageQueryResultLinksAmazonAffiliateLink
  )[];
  socialMediaAccounts: PublicPageQueryResultSocialMediaAccount[];
}

export interface PublicPageQueryResult {
  currentPage: PublicPageQueryResultPage;
}

const LinkpopQuery = (slug: string) => `
  query PublicPageQuery {
    currentPage(slug: "${slug}") {
      __typename
      id
      bio
      title
      slug
      storeUrl # TODO: Move all page related stuff to a fragment
      storefrontAccessToken
      media {
        id
        signedBlobId
        url
      }
      themeSettings  {
        backgroundColor
        backgroundStyle
        backgroundImage {
          id
          signedBlobId
          url
        }
        fontColor
        primaryFont
        secondaryFont
        linkCardShape
        linkCardColor
        linkCardFontColor
      }
      links {
        __typename
        id
        title
        ... on ExternalLink {
          url
          media {
            id
            signedBlobId
            url
          }
        }
        ... on AmazonAffiliateLink {
          url
          media {
            id
            signedBlobId
            url
          }
          description
          amazonPrice
        }
        ... on ShoppableLink {
          productId
        }
        ... on DovetaleAffiliateLink {
          productId
        }
        ... on SpotifyAlbumLink {
          url
        }
        ... on SpotifyArtistLink {
          url
        }
        ... on SpotifyPlaylistLink {
          url
        }
        ... on SpotifyPodcastLink {
          url
        }
        ... on SpotifyShowLink {
          url
        }
        ... on SpotifySongLink {
          url
        }
        ... on YouTubePlaylistLink {
          url
        }
        ... on YouTubeVideoLink {
          url
        }
      }
      socialMediaAccounts {
        id
        handle
        network
      }
    }
  }
`;

export default LinkpopQuery;
